/**
 * Tra concept theo mã cho các màn CHỈ ĐỌC (lịch chụp, ê-kíp, bể ca, đơn hàng).
 *
 * Đơn lưu MÃ concept. Ô chọn concept (ConceptPicker) đọc kho `GET /concepts`
 * từ QĐ 0096 nên bên tạo đơn thấy tên và ảnh, nhưng mọi chỗ HIỂN THỊ lại gọi
 * `conceptLabel(id)` với danh mục rỗng — chỉ tra được 12 concept gốc, concept
 * dựng sau (mã `custom_*`) rơi về chính mã. Thợ chụp mở ca ra đọc được
 * "custom_mt4p9Sak" thay vì "Nhẹ Nhàng".
 *
 * Lấy cả concept ĐÃ NGƯNG (`includeInactive`): ca đặt trước khi concept bị
 * ngưng vẫn phải gọi đúng tên — cùng lý do với useShiftGuides.
 *
 * Mọi màn dùng chung một truy vấn đã cache, nên cả trang lịch tốn đúng một
 * lượt đọc kho.
 */
import { useMemo } from "react";

import { useLookbookConcepts, type LookbookConcept } from "./api";
import { conceptNameOf } from "./helpers";

export type ConceptView = {
  /** Tên concept theo mã. Kho chưa tải / mã lạ → 12 tên gốc rồi về chính mã. */
  nameOf: (id: string | null | undefined) => string;
  /** Bản ghi concept để lấy ảnh. Chưa tải hoặc mã lạ → undefined. */
  conceptOf: (id: string | null | undefined) => LookbookConcept | undefined;
};

export function useConceptView(): ConceptView {
  const { data } = useLookbookConcepts(undefined, true);
  return useMemo(() => {
    const list = data ?? [];
    const byId = new Map(list.map((c) => [c.id, c]));
    // Đơn cũ có thể lưu TÊN thay vì mã (form sửa trên Lịch ghi nhầm trước
    // 19/08/2026) — cùng luật nhận cả hai như ConceptPicker.
    const byName = new Map(list.map((c) => [c.name, c]));
    const find = (id: string | null | undefined) => (id ? (byId.get(id) ?? byName.get(id)) : undefined);
    return {
      nameOf: (id) => (id ? (find(id)?.name ?? conceptNameOf(id, list)) : ""),
      conceptOf: find,
    };
  }, [data]);
}
